import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface Toast {
    id: number;
    title: string;
    message?: string;
    type: ToastType;
    duration?: number;
}

export const useToastStore = defineStore('toast', () => {
    const toasts = ref<Toast[]>([]);

    const addToast = (
        type: ToastType = 'info',
        title: string,
        message?: string,
        duration = 4000
    ) => {
        if (type === 'error' || type === 'warning') {
            const isDuplicate = toasts.value.some(
                (toast) => toast.type === type && toast.title === title && toast.message === message
            );
            if (isDuplicate) return;
        }

        const id = Date.now();
        toasts.value.push({ id, title, message, type, duration });

        window.setTimeout(() => {
            removeToast(id);
        }, duration);
    };

    const removeToast = (id: number) => {
        toasts.value = toasts.value.filter((toast) => toast.id !== id);
    };

    const removeAllToasts = () => {
        toasts.value = [];
    };

    const hasErrorOrWarningToasts = () => {
        return toasts.value.some((toast) => toast.type === 'error' || toast.type === 'warning');
    };

    return { toasts, addToast, removeToast, removeAllToasts, hasErrorOrWarningToasts };
});
